module.exports = __webpack_public_path__ + "img/mbti-table.ed7553d3.png";